import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Array to hold all notification objects
  items: [],
  // Count of unread notifications (often used for badges/icons)
  unreadCount: 0,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    // Action used by App.jsx to process real-time socket events
    receiveNotification: (state, action) => {
      const newNotification = {
        id: action.payload.id || action.payload._id || Date.now(), // Use DB ID or timestamp fallback
        type: action.payload.type || 'general',
        title: action.payload.title || 'New Update',
        message: action.payload.message || 'Check your updates.',
        read: false,
        createdAt: action.payload.createdAt || new Date().toISOString(),
        data: action.payload.data || {}, // Additional payload data (e.g., orderId, conversationId)
      };

      state.items.unshift(newNotification); // Add new notification to the start of the list
      state.unreadCount += 1;
    },

    // Example action to mark a single notification as read
    markOneAsRead: (state, action) => {
      const notification = state.items.find(item => item.id === action.payload.id);
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount -= 1;
      }
    },
    
    // Example action to mark all notifications as read
    markAllAsRead: (state) => {
      state.items.forEach(item => {
        item.read = true;
      });
      state.unreadCount = 0;
    },

    // Action used for initial data fetching (e.g., on app load)
    setNotifications: (state, action) => {
      state.items = action.payload;
      state.unreadCount = action.payload.filter(item => !item.read).length;
    },

    // Clear all notifications
    clearNotifications: (state) => {
        state.items = [];
        state.unreadCount = 0;
    }
  },
});

export const { 
    receiveNotification, 
    markOneAsRead, 
    markAllAsRead, 
    setNotifications,
    clearNotifications
} = notificationsSlice.actions;

export default notificationsSlice.reducer;

// NOTE: You must also add this reducer to your Redux store configuration file (store.js).